/**
 * 在原始 URL 的第一層子域名之後，插入 simplec-<agentId>
 * @param {string} fullUrl - 原始完整 URL
 * @returns {string} 處理後的 URL
 */

import { removeQabPrefix, removeUDot } from './domainUtils';

const insertAgentId = (fullUrl) => {
    const url = new URL(fullUrl);
    // 先檢查 hostname 是否包含 simplec-
    // UAT 的 url.hostname 格式：'qab01-simplec-251163418864.u.nova88.com/'
    // 想要 parse 成 simplec-251163418864.nova88.com
    if (url.hostname.includes('simplec-')) {
        // TODO: 這一段由於還無法吃到環境變數，所以當 UAT 的時候要移除 .u.
        // 理想上要吃環境變數
        if (url.hostname.includes('.u.')) {
            const hostname = removeQabPrefix(url.hostname);
            return removeUDot(hostname);
        }
        return url.hostname;
    }

    // domain with agentId query string
    const agentId = url.searchParams.get('agentId');
    if (!agentId) {
        return fullUrl;
    }

    if (url.hostname.startsWith('dev') && process.env.APP_ENV === 'local') {
        const parts = url.hostname.split('.');
        parts.splice(0, 2, `simplec-${agentId}`, parts[1]);
        url.hostname = parts.join('.');
        return url.hostname;
    }

    if (url.hostname.startsWith('dev') && process.env.APP_ENV === 'sit') {
        const parts = url.hostname.split('.');
        parts.splice(0, 2, `simplec-${agentId}`, 'playonesit');
        url.hostname = parts.join('.');
        return url.hostname;
    }

    if (process.env.APP_ENV === 'sit') {
        return `simplec-${agentId}.playonesit.com`;
    }

    return fullUrl;
};

export default insertAgentId;
